webpackJsonp([97786326051841],{

/***/ 439:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-582b2c50ebd5157dd0c7.js